module.exports = {"id":"182713","name":"Mërgim Mavraj","rating":"74","photo":"./data/images/photos/3/182713.png","club":{"name":"Hambourg SV","logo":"./data/images/clubs/HambourgSV.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MergimMavraj0.json
// module id = 2973
// module chunks = 0